export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  duration: string;
  region: string;
  description: string;
  poster: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateDate: string;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-movie-2-line' },
  { name: '国产电影', slug: 'chinese', icon: 'ri-china-railway-line' },
  { name: '好莱坞', slug: 'hollywood', icon: 'ri-global-line' },
  { name: '日韩电影', slug: 'japan-korea', icon: 'ri-earth-line' },
  { name: '动作片', slug: 'action', icon: 'ri-fire-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '科幻片', slug: 'sci-fi', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-palette-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    originalTitle: 'The Wandering Earth 3',
    year: 2026,
    category: '科幻片',
    categorySlug: 'sci-fi',
    rating: 8.7,
    duration: '148分钟',
    region: '中国大陆',
    description: '太阳急速老化，持续膨胀，地球面临被吞没的危机。人类再次启动流浪地球计划，带着地球去往4.2光年外的新家园。在这场跨越时空的冒险中，人类将面临前所未有的挑战。',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20sci-fi%20space%20adventure%20with%20giant%20planet%20and%20spaceship%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20dark%20background%20with%20blue%20and%20orange%20accents%2C%20clean%20simple%20composition%2C%20movie%20poster%20aesthetic%2C%20professional%20film%20key%20art%2C%20minimal%20text%20area%20at%20bottom%2C%20cinematic%20color%20grading%2C%20atmospheric%20with%20stars%20and%20nebula%2C%20high%20contrast%2C%20polished%20commercial%20film%20poster%20look&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    tags: ['科幻', '冒险', '灾难'],
    isHot: true,
    isNew: false,
    updateDate: '2026-08-10',
  },
  {
    id: '2',
    title: '长安三万里2',
    originalTitle: 'Chang An 2',
    year: 2026,
    category: '国产电影',
    categorySlug: 'chinese',
    rating: 9.1,
    duration: '168分钟',
    region: '中国大陆',
    description: '安史之乱后，大唐由盛转衰。诗人高适困守孤城，回忆与李白的一生交往，两位伟大诗人的人生轨迹在历史的洪流中交织，谱写出一曲荡气回肠的盛唐挽歌。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%2C%20ancient%20Tang%20dynasty%20palace%20and%20poetry%20theme%2C%20elegant%20traditional%20Chinese%20ink%20painting%20style%2C%20warm%20golden%20and%20red%20tones%2C%20poetic%20atmosphere%2C%20beautiful%20landscape%20with%20mountains%20and%20plum%20blossoms%2C%20clean%20simple%20composition%2C%20artistic%20film%20poster%20design&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    tags: ['动画', '历史', '诗歌'],
    isHot: true,
    isNew: true,
    updateDate: '2026-08-11',
  },
  {
    id: '3',
    title: '速度与激情12',
    originalTitle: 'Fast & Furious 12',
    year: 2026,
    category: '好莱坞',
    categorySlug: 'hollywood',
    rating: 7.9,
    duration: '142分钟',
    region: '美国',
    description: '唐老大和他的家族再次集结，面对前所未有的全球威胁。从迪拜到东京，从里约到伦敦，惊险刺激的飙车追逐和极限特技将再次点燃银幕。',
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%2C%20fast%20sports%20cars%20racing%20on%20city%20streets%20at%20night%2C%20dramatic%20explosions%20in%20background%2C%20dark%20urban%20setting%20with%20neon%20lights%2C%20high%20octane%20energy%2C%20clean%20composition%2C%20professional%20blockbuster%20film%20poster%20style%2C%20cinematic%20lighting%2C%20bold%20colors&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    tags: ['动作', '犯罪', '飙车'],
    isHot: true,
    isNew: false,
    updateDate: '2026-08-08',
  },
  {
    id: '4',
    title: '铃芽之旅2',
    originalTitle: 'Suzume 2',
    year: 2026,
    category: '日韩电影',
    categorySlug: 'japan-korea',
    rating: 8.5,
    duration: '122分钟',
    region: '日本',
    description: '铃芽再次踏上冒险之旅，这一次她发现了一扇通往过去的门。在时间与记忆的交织中，她必须面对内心最深处的伤痛，寻找治愈与和解的力量。',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%2C%20beautiful%20young%20girl%20standing%20before%20a%20mysterious%20door%20in%20a%20dreamlike%20landscape%2C%20soft%20pastel%20colors%20with%20cherry%20blossoms%2C%20magical%20atmosphere%2C%20clean%20simple%20composition%2C%20artistic%20anime%20film%20key%20visual%2C%20gentle%20lighting%2C%20emotional%20and%20poetic%20mood&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    tags: ['动画', '奇幻', '冒险'],
    isHot: true,
    isNew: true,
    updateDate: '2026-08-12',
  },
  {
    id: '5',
    title: '怒火重案2',
    originalTitle: 'Raging Fire 2',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.2,
    duration: '128分钟',
    region: '中国香港',
    description: '重案组督察张崇邦在一次行动中发现了一个涉及国际犯罪组织的惊天阴谋。一场正义与邪恶的较量在港岛展开，拳拳到肉的动作场面令人热血沸腾。',
    poster: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20crime%20movie%20poster%2C%20police%20officer%20in%20dark%20alley%20with%20rain%2C%20neon%20signs%20reflecting%20on%20wet%20ground%2C%20dramatic%20noir%20lighting%2C%20intense%20atmosphere%2C%20clean%20composition%2C%20professional%20film%20poster%20design%2C%20gritty%20urban%20aesthetic%2C%20high%20contrast%20shadows&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    tags: ['动作', '警匪', '犯罪'],
    isHot: false,
    isNew: true,
    updateDate: '2026-08-09',
  },
  {
    id: '6',
    title: '热辣滚烫2',
    originalTitle: 'YOLO 2',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.4,
    duration: '130分钟',
    region: '中国大陆',
    description: '乐莹在经历了上一次的自我蜕变后，开启了全新的人生篇章。这一次，她不仅要面对事业上的挑战，还要在爱情与友情中寻找平衡，笑料百出的同时也不乏温暖感动。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20cheerful%20woman%20with%20bright%20smile%20in%20modern%20urban%20setting%2C%20warm%20golden%20sunlight%2C%20feel-good%20atmosphere%2C%20colorful%20and%20vibrant%20composition%2C%20clean%20simple%20design%2C%20professional%20film%20poster%20style%2C%20positive%20uplifting%20mood%2C%20friendly%20and%20approachable%20aesthetic&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    tags: ['喜剧', '励志', '剧情'],
    isHot: true,
    isNew: false,
    updateDate: '2026-08-07',
  },
  {
    id: '7',
    title: '封神第二部',
    originalTitle: 'Creation of the Gods II',
    year: 2026,
    category: '国产电影',
    categorySlug: 'chinese',
    rating: 8.6,
    duration: '150分钟',
    region: '中国大陆',
    description: '姬发从朝歌逃回西岐后，殷商大军压境。在姜子牙和众神的帮助下，姬发率领西岐军民奋起抵抗。一场关乎天下苍生命运的大战即将拉开帷幕。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%2C%20ancient%20warriors%20in%20armor%20with%20mythical%20beasts%2C%20dramatic%20battlefield%20with%20lightning%20and%20fire%2C%20dark%20stormy%20sky%2C%20epic%20scale%2C%20clean%20composition%2C%20professional%20fantasy%20film%20poster%20design%2C%20cinematic%20lighting%2C%20golden%20and%20crimson%20accents&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    tags: ['奇幻', '史诗', '神话'],
    isHot: true,
    isNew: false,
    updateDate: '2026-08-06',
  },
  {
    id: '8',
    title: '哥斯拉大战金刚3',
    originalTitle: 'Godzilla vs Kong 3',
    year: 2026,
    category: '好莱坞',
    categorySlug: 'hollywood',
    rating: 7.6,
    duration: '135分钟',
    region: '美国',
    description: '当一个新的远古巨兽从地心苏醒，哥斯拉和金刚必须再次联手对抗这个前所未有的威胁。地球的命运悬于一线，两大巨兽的终极之战在全球各地上演。',
    poster: 'https://readdy.ai/api/search-image?query=Monster%20movie%20poster%2C%20giant%20creatures%20fighting%20in%20destroyed%20cityscape%2C%20dramatic%20explosions%20and%20smoke%2C%20dark%20apocalyptic%20sky%2C%20epic%20scale%20with%20tiny%20buildings%20below%2C%20clean%20composition%2C%20professional%20blockbuster%20film%20poster%20style%2C%20cinematic%20color%20grading%2C%20intense%20action&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    tags: ['动作', '科幻', '怪兽'],
    isHot: false,
    isNew: true,
    updateDate: '2026-08-11',
  },
  {
    id: '9',
    title: '隐秘的角落电影版',
    originalTitle: 'The Bad Kids Movie',
    year: 2026,
    category: '国产电影',
    categorySlug: 'chinese',
    rating: 8.8,
    duration: '118分钟',
    region: '中国大陆',
    description: '三个孩子在景区游玩时意外拍下一桩谋杀案，从此陷入一场无法逃脱的漩涡。真相与谎言、善与恶的边界逐渐模糊，每个人的秘密都将被一一揭开。',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20three%20children%20silhouettes%20against%20a%20misty%20mountain%20landscape%2C%20dark%20mysterious%20atmosphere%2C%20cold%20blue-grey%20tones%2C%20sense%20of%20danger%20and%20secrecy%2C%20clean%20composition%2C%20professional%20film%20poster%20design%2C%20minimal%20and%20elegant%20aesthetic%2C%20psychological%20thriller%20mood&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    tags: ['悬疑', '犯罪', '剧情'],
    isHot: true,
    isNew: false,
    updateDate: '2026-08-05',
  },
  {
    id: '10',
    title: '鬼灭之刃剧场版',
    originalTitle: 'Demon Slayer Movie',
    year: 2026,
    category: '动漫',
    categorySlug: 'anime',
    rating: 8.9,
    duration: '110分钟',
    region: '日本',
    description: '炭治郎一行人接到了新的任务，前往一个被恶鬼肆虐的村庄。在那里，他们将面对实力远超以往的强敌，同时也会揭开隐藏在鬼杀队历史中的惊人秘密。',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20action%20movie%20poster%2C%20warrior%20with%20katana%20sword%20in%20dynamic%20pose%2C%20water%20and%20fire%20effects%20surrounding%2C%20vibrant%20colors%20with%20dark%20background%2C%20intense%20battle%20atmosphere%2C%20clean%20composition%2C%20professional%20anime%20film%20key%20visual%2C%20stylish%20and%20modern%20design%2C%20high%20energy&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    tags: ['动画', '动作', '奇幻'],
    isHot: true,
    isNew: true,
    updateDate: '2026-08-12',
  },
  {
    id: '11',
    title: '地球脉动电影版',
    originalTitle: 'Planet Earth The Movie',
    year: 2026,
    category: '纪录片',
    categorySlug: 'documentary',
    rating: 9.5,
    duration: '96分钟',
    region: '英国',
    description: '从北极冰原到热带雨林，从深海峡谷到高山之巅，本片用前所未有的视角展现地球最壮丽的自然奇观和动物世界的动人故事。每一帧都是一幅绝美画卷。',
    poster: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20movie%20poster%2C%20stunning%20aerial%20view%20of%20Earth%20landscape%20with%20wildlife%2C%20vibrant%20green%20forests%20and%20blue%20oceans%2C%20majestic%20animals%20in%20natural%20habitat%2C%20clean%20composition%2C%20professional%20film%20poster%20design%2C%20beautiful%20natural%20lighting%2C%20awe-inspiring%20and%20breathtaking%20visuals&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    tags: ['纪录片', '自然', '动物'],
    isHot: false,
    isNew: false,
    updateDate: '2026-08-03',
  },
  {
    id: '12',
    title: '咒怨重启',
    originalTitle: 'Ju-On Reboot',
    year: 2026,
    category: '恐怖片',
    categorySlug: 'horror',
    rating: 7.4,
    duration: '105分钟',
    region: '日本',
    description: '一栋普通的日式住宅中，隐藏着无法消解的诅咒。每一个踏入这栋房子的人都将遭遇无法逃脱的恐怖命运。经典的日式恐怖全面升级，带来全新的心理恐惧体验。',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20horror%20movie%20poster%2C%20haunted%20traditional%20house%20in%20darkness%2C%20pale%20ghostly%20figure%20with%20long%20black%20hair%2C%20cold%20blue%20and%20grey%20tones%2C%20creepy%20atmosphere%2C%20clean%20composition%2C%20minimal%20horror%20film%20poster%20design%2C%20psychological%20fear%20aesthetic%2C%20subtle%20dread%20mood&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    tags: ['恐怖', '惊悚', '超自然'],
    isHot: false,
    isNew: true,
    updateDate: '2026-08-10',
  },
  {
    id: '13',
    title: '星际穿越重启版',
    originalTitle: 'Interstellar Reborn',
    year: 2026,
    category: '科幻片',
    categorySlug: 'sci-fi',
    rating: 9.3,
    duration: '169分钟',
    region: '美国',
    description: '在不远的未来，地球资源日渐枯竭。前NASA宇航员库珀再次穿越虫洞，前往未知星系为人类寻找新家园。在浩瀚宇宙中，时间与空间、爱与生存的终极命题将被重新定义。',
    poster: 'https://readdy.ai/api/search-image?query=Space%20exploration%20sci-fi%20movie%20poster%2C%20astronaut%20floating%20near%20a%20wormhole%20with%20distant%20galaxies%2C%20deep%20space%20with%20stars%20and%20nebula%2C%20dark%20cosmic%20background%2C%20clean%20composition%2C%20professional%20film%20poster%20design%2C%20cinematic%20epic%20scale%2C%20mysterious%20and%20beautiful%20universe&width=600&height=900&seq=movie-poster-13&orientation=portrait',
    tags: ['科幻', '冒险', '剧情'],
    isHot: false,
    isNew: false,
    updateDate: '2026-08-04',
  },
  {
    id: '14',
    title: '独行月球2',
    originalTitle: 'Moon Man 2',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.1,
    duration: '125分钟',
    region: '中国大陆',
    description: '独孤月以为自己是月球上最后一个人，没想到在月球背面竟然还有另一个幸存者。两个人在荒凉的月球上展开了一场啼笑皆非又感人至深的太空冒险。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20space%20comedy%20movie%20poster%2C%20astronaut%20standing%20on%20moon%20surface%20with%20Earth%20in%20background%2C%20fun%20and%20quirky%20style%2C%20bright%20starfield%2C%20clean%20composition%2C%20professional%20film%20poster%20design%2C%20warm%20humorous%20tone%2C%20colorful%20space%20aesthetic%2C%20lighthearted%20mood&width=600&height=900&seq=movie-poster-14&orientation=portrait',
    tags: ['喜剧', '科幻', '剧情'],
    isHot: false,
    isNew: false,
    updateDate: '2026-08-02',
  },
  {
    id: '15',
    title: '寄生虫2',
    originalTitle: 'Parasite 2',
    year: 2026,
    category: '日韩电影',
    categorySlug: 'japan-korea',
    rating: 8.3,
    duration: '132分钟',
    region: '韩国',
    description: '金家在经历了上一次的事件后，各自踏上了不同的人生道路。然而命运再次将他们与朴家的残余成员联系在一起。阶级、欲望与生存的残酷游戏在新的舞台上再次上演。',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20movie%20poster%2C%20modern%20architecture%20house%20with%20stairs%20and%20shadows%2C%20social%20class%20contrast%20theme%2C%20dark%20dramatic%20lighting%2C%20cold%20and%20warm%20tone%20contrast%2C%20clean%20minimal%20composition%2C%20professional%20arthouse%20film%20poster%20design%2C%20sophisticated%20and%20tense%20mood&width=600&height=900&seq=movie-poster-15&orientation=portrait',
    tags: ['剧情', '悬疑', '社会'],
    isHot: false,
    isNew: true,
    updateDate: '2026-08-11',
  },
  {
    id: '16',
    title: '大闹天宫重制版',
    originalTitle: 'Havoc in Heaven Remastered',
    year: 2026,
    category: '动漫',
    categorySlug: 'anime',
    rating: 9.0,
    duration: '98分钟',
    region: '中国大陆',
    description: '中国经典动画的全新重制版本。孙悟空大闹天宫的故事以现代动画技术重新演绎，在保留经典韵味的同时带来震撼的视觉体验。每一个中国人心中的齐天大圣，回来了。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20classic%20animated%20movie%20poster%2C%20Monkey%20King%20Sun%20Wukong%20in%20dynamic%20fighting%20pose%20with%20golden%20armor%2C%20traditional%20Chinese%20cloud%20patterns%20and%20palace%20elements%2C%20vibrant%20red%20and%20gold%20colors%2C%20clean%20composition%2C%20professional%20animation%20film%20key%20visual%2C%20heroic%20and%20mythical%20atmosphere&width=600&height=900&seq=movie-poster-16&orientation=portrait',
    tags: ['动画', '神话', '经典'],
    isHot: false,
    isNew: false,
    updateDate: '2026-08-01',
  },
];

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);
export const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);